import cn from 'classnames';
import styles from './addskuheader.module.scss';
import { formatPriceTypeHourly } from '@utils/currency';
import { Sku } from 'types/sku.types';

type AddSkuHeaderProps = {
  sku: Sku;
  isConfirmation: boolean;
  hideHeaderPrice: boolean;
  itemDisplayPrice: string;
  showDiscountAppliedLater: boolean;
};

export default function AddSkuHeader({
  sku,
  isConfirmation = false,
  hideHeaderPrice = false,
  itemDisplayPrice = '',
  showDiscountAppliedLater = false,
}: AddSkuHeaderProps) {
  const skuHeaderStyle = cn({ [styles.confirmationHeader]: isConfirmation });
  return (
    <div className="flex justifyContentSpaceBetween alignItemsCenter paddingY-small1">
      <h3 className={skuHeaderStyle}>{sku.name}</h3>
      {!hideHeaderPrice && (
        <h2 className="paddingLeft-small1">
          {formatPriceTypeHourly({ sku, price: itemDisplayPrice })}
          {showDiscountAppliedLater && <span>*</span>}
        </h2>
      )}
    </div>
  );
}
